import React from "react"
import ReactDOMServer from "react-dom/server";
import { AiFillCaretDown } from "react-icons/ai";
import COLORS from "scss/colors.module.scss";
import { DIMENSIONS } from "utils/Dimensions";
import { getTitle } from "../../helpers/getTitle";
import chroma from "chroma-js";

var clickCount = 0

export default class CheckboxGroupColumnRenderer {

  getChips(params) {
    var temp = [];
    if (params.data?.row_id !== "+") {
      params.columnOptions.options.map((option, index) => {
        let backgroundColor = params.columnOptions.colors ? params.columnOptions.colors[index] : "#808080";
        let textColor =
          chroma.contrast(backgroundColor, COLORS.PRIMARY_COLOR) > 2
            ? COLORS.PRIMARY_COLOR
            : COLORS.SECONDARY_COLOR;
        let isCheckedOption = this.values.includes(typeof option == "string" ? option.trim() : option);
        temp.push(
          `<div
         key=${index}
         class="d-flex"
         >
        <div
        class="multiSelectChipsContainer"
        >
          <svg
            viewBox="0 0 22 14"
            height="17.6"
            width="17.6"
            xmlns="http://www.w3.org/2000/svg"
          >
          <path  
            fillRule="evenodd"
            fill=${backgroundColor} 
            d=${
              isCheckedOption
                ? "'M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM7 12.414l-3.707-3.707 1.414-1.414 1.293 1.293 3.793-3.793 1.414 1.414-6.207 6.207z'"
                : "'M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM14 14h-12v-12h12v12z'"
            } >
          </path>
          </svg>
          <div
            class="checkBoxChip"
            style="color:${textColor};background-color:${backgroundColor}; height: 26px;
            max-width: ${params.colDef.width - 34}px;"
          >
            ${option ? option : ""}
          </div>
        </div>
        ${
          index === 4 && params.columnOptions.options.length > 5
            ? '<div class="checkBoxEllipsis">...</div>'
            : ""
        }
        </div>`
        );
      });
    }
    return temp.join("");
  }

  showDownArrow(params) {
    if (params.value !== undefined) {
      return ReactDOMServer.renderToStaticMarkup(<AiFillCaretDown />)
    }
    return ""
  }

  init(params) {
    if (params.data?.row_id === "+") {
      this.htmlElement = "";
    }
    this.values =
      params.value && params.value !== "+r0w" ? params.value?.split(",") : [];
    for (let i = 0; i < this.values.length; i++) {
      this.values[i] = this.values[i].trim();
    }

    this.clickHandler = function clickHandler() {
      clickCount = clickCount + 1
      if (clickCount > 1 && 
        params.store.prevClickedCellRowId ===
          params.api.getFocusedCell()?.rowIndex &&
        params.store.prevClickedCellColumnId ===
          params.api.getFocusedCell()?.column.colDef.cellRendererParams.columnId
      ) {
        params.api.startEditingCell({
          colKey: params.colDef.colId,
          rowIndex: params.rowIndex,
        });
        clickCount = 0
      }
    }

    this.handleExpanderClicked = function handleExpanderClicked(event) {
      event.stopPropagation();
      params.store.isGridCellEditing=true;
      params.colDef.store.setIsCheckBoxGroupDialogOpen(true);
      params.api.startEditingCell({
        colKey: params.colDef.colId,
        rowIndex: params.rowIndex,
      });
    };

    this.agGridProps = params;
    const clickedGridCell = params.eGridCell;
    clickedGridCell.addEventListener("focus", function (event) {
      const src = event.target;
      const srcTop = src.getBoundingClientRect().top;
      if (window.innerHeight - srcTop < (params.store.isSubsheet ? 400 : 300)) {
        src.style.position = "absolute";
        src.style.bottom = "0px";
      }
    });
    clickedGridCell.addEventListener("focusout", function (event) {
      if (!params.store.isGridCellEditing) {
        const src = event.target;
        src.style.position = "absolute";
        src.style.bottom = "";
      }
    });
    this.htmlElement = document.createElement('div')
    this.htmlElement.className = "multiSelectCellContainer"
    this.htmlElement.style =
      "min-height:" +
      (Number(params.node.rowHeight) - 6) +
      "px; flexWrap: " +
      (params.node.rowHeight <= DIMENSIONS.cell_height_medium
        ? "nowrap"
        : "wrap");
    this.htmlElement.title = getTitle(params, params.cellMetaData)
    this.htmlElement.onclick = this.clickHandler
    this.htmlElement.innerHTML = `<div
                                  class="multiSelectCellContainer checkBoxCell"
                                  id="multiSelectCell"
                                  style="flexWrap: ${
                                    params.node.rowHeight <=
                                    DIMENSIONS.cell_height_short
                                      ? "nowrap"
                                      : "wrap"
                                  };max-height: 150px !important; display: inline-block; padding-top:${
                                    params.node.rowHeight <= DIMENSIONS.cell_height_compact
                                      ? "2px"
                                      : params.node.rowHeight <= DIMENSIONS.cell_height_short
                                      ? "8px"
                                      : "0px"
                                  }"
                                >
                                  ${this.getChips(params)}
                                </div>
                                <div class="multiselect_down_arrow">
                                ${this.showDownArrow(params)}
                                </div>`;

    this.expanderElement = document.createElement("div");
    this.expanderElement.className = "expandArrow checkBoxExpander";
    this.expanderElement.style =
      "position: absolute;right: 5px;top: 5px;line-height: normal;";
    this.expanderElement.onclick = this.handleExpanderClicked;
    this.expanderElement.innerHTML = `<svg
                                        stroke="currentColor" 
                                        fill="currentColor"
                                        stroke-width="0"
                                        viewBox="0 0 448 512"
                                        size="14"
                                        height="14"
                                        width="14"
                                        xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path 
                                            d="M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z">
                                          </path>
                                        </svg>`;
    this.htmlElement.appendChild(this.expanderElement);
  }

  getGui() {
    return this.htmlElement;
  };

  destroy() {
    clickCount = 0
  }
}
